import React, { useState } from "react";

import { useNavigate } from 'react-router-dom';
import { 
  CssBaseline,
} from '@mui/material';

import { 
  AuthService,
  LoginContainer,
  LoginTemplate,
  loginUser,
  useMessageDispatch,
} from 'itaf';

import { AppRoutes } from "../../routes";

const http = AuthService;

export default function Login () {
  const history = useNavigate();

  const setMessage = useMessageDispatch();

  const [isLoading, setLoading] = useState(false);

  function loginClicked(username, password) {
    setLoading(true);
    
    http.login(username, password)
      .then((response) => {
        loginUser(response);

        history(AppRoutes.APP);
      })
      .catch((e) => {
        if (e.status === 404) {
          setMessage({ hasError: true, text: 'Usuário ou senha inválidos!' });
        } else {
          setMessage({ hasError: true, text: 'Problema ao fazer login. Entre em contato com o suporte.' });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className="Login">
      <CssBaseline />
      <LoginTemplate title="Login">
        <LoginContainer
          isLoading={isLoading}
          onLoginClick={(username, password) => loginClicked(username, password)}
        />
      </LoginTemplate>
    </div>
  );
}
